import './App.css'
import {Link} from 'react-router-dom'
function Jumbotron(){
    return(
        <div className="jumbotron jumb text-light">

        <h1 className="display-4"><span className="text-warning font-weight-bold">Hello, </span>we are DDAI!</h1><br/>
        <pre >Here we are for you to provide a service </pre> 
        <pre>were you guys can find meaning to new words,</pre>
        <pre>transcribe and translate any sentences using our DDAI AI system...</pre>
        <p className="my-5" />

        <div className = "ml-auto">
       
        <Link className="btn btn-warning btn-lg mr-auto" to="/about" role="button">Would you like to Know us?</Link>
        </div>
       <br/>
       <br/>
       <br/>
       <br/>
       
     </div>
        )
}

export default Jumbotron